(function () {
    'use strict';

    angular
        .module('skillsApp')
        .controller('AddSkillController', AddSkillController);

    function AddSkillController($state, $scope, $stateParams, $q, $translate, logger, config, clusterAction, catalogItems, dataService, portalGroupService, modalDialogService) {
        var vm = this;

        vm.item = clusterAction.item;
        vm.changeVector = clusterAction.changeVector;

        vm.assignments = [];
        vm.catalogItems = catalogItems;
        
        vm.departmentsFunctionsLink = {
            addAllDepartments: false,
            addAllFunctions: false,
            userChosenFunctions: [],
            userChosenDepartments: []
        };

        vm.dropDownDepartmentSettings = {
            idProp: 'id',
            displayProp: 'name',
            selectTitle: $translate.instant('specific_departments') + '...'
        };

        vm.dropDownFunctionSettings = {
            idProp: 'roleId',
            displayProp: 'roleName',
            selectTitle: $translate.instant('specific_functions') + '...'
        };

        vm.addAssignment = addAssignment;
        vm.allDepartments = allDepartments;
        vm.allFunctions = allFunctions;
        vm.cancel = cancel;
        vm.removeAssignment = removeAssignment;
        vm.save = save;
             
        function addAssignment() {
            return modalDialogService.openSelectDepartmentFunctionsDialog().then(assignments => {

                for (var i = 0; i < assignments.length; i++) {
                    var assignment = assignments[i];
                    var found = false;
                    for (var j = 0; j < vm.assignments.length; j++) {
                        if (vm.assignments[j].department.id === assignment.department.id && vm.assignments[j].function.roleId === assignment.function.roleId) {
                            found = true;
                            break;
                        }
                    }

                    if (!found) vm.assignments.push(assignment);
                }
            });
        }

        function allDepartments() {
            vm.departmentsFunctionsLink.userChosenDepartments = [];
        }

        function allFunctions() {
            vm.departmentsFunctionsLink.userChosenFunctions = [];
        }

        function cancel() {
            $state.go('^');
        }

        function removeAssignment(assignment) {
            var idx = vm.assignments.indexOf(assignment);
            vm.assignments.splice(idx, 1);
        }

        function save(formData) {

            if (!formData.$valid) {
                logger.error('some_mandatory_fields_have_not_yet_been_filled');
                return $q.reject();
            }
            
            if (vm.assignments.length === 0) {
                logger.error('select_departments_or_functions');
                return $q.reject();
            }

            var newSkill = angular.copy(vm.item);
            
            if (config.settings.custom.examinerRequiredFor) {
                var examinersRequired = false;
                for (var x = 0; x < config.settings.custom.examinerRequiredFor.length; x++) {
                    var t = config.settings.custom.examinerRequiredFor[x].toLowerCase();
                    for (var y = 0; y < newSkill.activityGroups.length; y++) {
                        var ag = newSkill.activityGroups[y];
                        for (var z = 0; z < ag.activities.length; z++) {
                            var a = ag.activities[z];

                            if (a.targetId !== undefined && a.targetId !== null) continue; // skip classroom items

                            if (a.type === t && (a.examiners === undefined || a.examiners.length === 0)) {
                                examinersRequired = true;
                                break;
                            }
                        }
                        if (examinersRequired == true) break;
                    }
                    if (examinersRequired == true) break;
                }

                if (examinersRequired) {
                    logger.error('for_one_or_more_activities_no_assessors_have_been_added_yet');
                    return $q.reject();
                }
            }

            newSkill.actionId = newSkill.id;
            delete newSkill.id;
            delete newSkill.createdDate;
                        
            return dataService.createSkills(newSkill, vm.changeVector, vm.assignments)
                .then(result => {
                    logger.success('successfully_saved');
                    $state.go('^');
                });
        }
    }
})();